import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-231" data-mp="3fxkxijk6olo7">
      <div className="mx-auto max-w-6xl" data-id="element-232" data-mp="3azt2vhs5mlgb">
        <SectionHeading eyebrow="4.9/5 · +1.500 profes" title={<>
              Lo que dicen <span className="text-brand" data-id="element-234" data-mp="36wwf7cnrbz5i">los colegas</span>
            </>} data-id="element-233" data-mp="3ayqbl8qx6gzv" />

        <div className="mt-14 grid gap-5 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-235" data-mp="31z37ugapwz3n">
          <Reveal data-id="element-236" data-mp="2x00552i7n4yu">
            <figure className="flex h-full flex-col rounded-3xl border-2 border-ink bg-ink p-8 sm:p-12" data-id="element-237" data-mp="2x1kywpwpajvn">
              <Stars className="text-volt" data-id="element-238" data-mp="2s39pggabibdy" />
              <blockquote className="mt-7 flex-1 font-display text-2xl leading-[1.15] text-white sm:text-4xl" data-id="element-239" data-mp="v9g9bl2obyo3">
                “{featured.quote}”
              </blockquote>
              <figcaption className="mt-9 border-t border-white/15 pt-6" data-id="element-240" data-mp="q893hrk3d9k2">
                <p className="font-display text-lg text-volt" data-id="element-241" data-mp="h55ba4bmvzy5">
                  {featured.name}
                </p>
                <p className="mt-1 text-sm text-white/60" data-id="element-242" data-mp="m6cio29v6x4a">
                  {featured.role} · {featured.location}
                </p>
              </figcaption>
            </figure>
          </Reveal>

          <div className="grid gap-5" data-id="element-243" data-mp="c73phbmtpmiz">
            {rest.map((item, index) => <Reveal key={item.name} delay={0.05 + index * 0.05} data-id="element-244" data-mp="zxh8kcnfkb1f" data-mpi={index}>
                <figure className="flex h-full flex-col rounded-3xl border-2 border-ink bg-bone p-7" data-id="element-245" data-mp="14v9cy659hpmi">
                  <Stars className="text-brand" data-id="element-246" data-mp="q6wb4sjhtck3" />
                  <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink/80" data-id="element-247" data-mp="q63dch2ihxe3">
                    “{item.quote}”
                  </blockquote>
                  <figcaption className="mt-6" data-id="element-248" data-mp="1ius71v18n0ft">
                    <p className="font-display text-base text-ink" data-id="element-249" data-mp="1itz9nko65nac">
                      {item.name}
                    </p>
                    <p className="mt-0.5 text-sm text-ink/55" data-id="element-250" data-mp="1xi0mj81kxrxl">
                      {item.role} · {item.location}
                    </p>
                  </figcaption>
                </figure>
              </Reveal>)}
          </div>
        </div>

        <p className="mt-10 text-center text-xs text-ink/40" data-id="element-251" data-mp="1og9g20z7th2o">
          Testimonios ilustrativos con fines demostrativos.
        </p>
      </div>
    </section>;
}
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-1 ${className}`} aria-label="5 estrellas de 5" data-id="element-252" data-mp="1el7u1e08kv4b">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-253" data-mp="14t22g5dwcfpn" data-mpi={index} />)}
    </div>;
}